<template>
<div class="overall-container">
    <p>Messages and enquiries from the school's contact form</p>
  <div class="messaging container flex">
    <div :class="{phone: mobile}" class="messaging-preview">
      <h1>Messages</h1>
      <div class="desktop-view">
        <div
          @click="toggleInbox"
          class="flex message-menu"
          :class="{active: showInbox}">
          <p class="chip">Received</p>
          <MailIcon class="icon"/>
        </div>
      </div>
      <div :class="{mobileview: mobile}" class="view-mobile">
        <mail-box
          v-if="showInbox"
          :messages="recordsI"
          :messager="currentUser"
          @messageDeleted="toggleInbox"
        />
      </div>
    </div>
    <div :class="{mobile: mobile}" class="messaging-full">
      <mail-box
        v-if="showInbox"
        :messages="recordsI"
        :messager="currentUser"
        @messageDeleted="toggleInbox"
      />
    </div>
  </div>
  </div>
</template>

<script>
import { db, collection, query, onSnapshot, orderBy } from '@/firebase/config'
import { inject, onBeforeUnmount, onMounted, ref } from 'vue'
import { MailIcon } from '@heroicons/vue/outline'
import MailBox from '../../components/MailBox.vue'

export default {
  components: { MailIcon, MailBox },
  setup () {
    const currentUser = inject('currentUser')
    const windowWidth = ref(null)
    const mobile = ref(false)
    const showInbox = ref(true)
    const recordsI = ref([])
    const storedInRef = ref('contact-form')

    const qI = query(collection(db, '/schools/inspire-schools/' + storedInRef.value), orderBy('createdAt', 'desc'))

    const toggleInbox = () => {
      //  set toast to true('toasts')
      showInbox.value = !showInbox.value
    }

    const unsubI = onSnapshot(qI, (querySnapshot) => {
      recordsI.value = []
      querySnapshot.forEach((doc) => {
        recordsI.value.push({ ...doc.data(), id: doc.id })
      })
    })
    onBeforeUnmount(() => {
      unsubI()
    })

    const handleview = () => {
      windowWidth.value = window.innerWidth
      if (windowWidth.value <= 600) {
        mobile.value = true
        return
      }
      mobile.value = false
    }

    onMounted(() => {
      handleview()
      window.addEventListener('resize', handleview)
    })

    return { currentUser, recordsI, toggleInbox, showInbox, mobile }
  }
}
</script>

<style>
.messaging {
  color: black;
  min-height: 60vh;
  background: #f1f1f1;
  justify-content: space-around;
  padding: 8px 4px;
}
.messaging-preview {
  background: #fff;
  flex-basis: 35%;
}
.messaging-full {
  background: #ddd;
  flex-basis: 60%;
}
.messaging .icon {
  width: 24px;
}
.message-menu {
  justify-content: space-between;
  cursor: pointer;
  margin: 6px;
  padding: 3px;
  transition: 0.5s ease-in-out all;
}
.message-menu:hover {
  background: #ddd;
}
.messaging .active {
  background: rgba(14, 75, 62, 0.4);
}
.messaging .phone {
  flex-basis: 85%;
}
.messaging .mobile {
  display: none;
}
.messaging .view-mobile {
  display: none;
}
.messaging .mobileview {
  display: block;
  z-index: 3;
  margin-top: 30px;
}
</style>
